import { render } from "./MenuControl.vue?vue&type=template&id=7b547fbd&scoped=true"
import script from "./MenuControl.vue?vue&type=script&lang=js"
export * from "./MenuControl.vue?vue&type=script&lang=js"

import "./MenuControl.vue?vue&type=style&index=0&id=7b547fbd&scoped=true&lang=css"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b547fbd"]])

export default __exports__